import { useContext, useEffect, useMemo } from "react"
import { AppContext } from "@utils/AppContext"
import { HOME_PAGE_TYPE } from "@utils/CONST"
import { useNavigate, useLocation }from "react-router-dom"; 
import styles from './index.module.scss'

const SwitchHomePageType = (props) => {
    const { globalHomePageType, updateGlobalHomePageType } = useContext(AppContext)
    const navigate = useNavigate();
    const location = useLocation();

    const clothActived = useMemo(() => {
        return globalHomePageType == HOME_PAGE_TYPE.CLOTHING
    }, [globalHomePageType])

    const onSwitch = (type) => {
        if (globalHomePageType != type || location.pathname == '/home/homemain/personalCenter') {
            if (type == HOME_PAGE_TYPE.CLOTHING) navigate("/home/homemain/model")
            else navigate("/home/homemain/commodity")
        }
    }

    return (
        <div className={styles.Container}>
            <div className={styles.SliderBar} style={{ left: `${clothActived ? '0%' : '50%'}` }}></div>
            <div className={`${styles.SelectItem} ${clothActived && styles.actived}`} onClick={() => onSwitch(HOME_PAGE_TYPE.CLOTHING)}>服装版</div>
            <div className={`${styles.SelectItem} ${!clothActived && styles.actived}`} onClick={() => onSwitch(HOME_PAGE_TYPE.MERCHANDISE)}>商品版</div>
        </div>
    )
}

export default SwitchHomePageType